import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Book, Heart, MessageCircle, Brain, Shield, Link, AlertCircle, List, Clock } from 'lucide-react';
export function StackSection() {
  const tomos = [{
    title: 'El Mapa del Alma de tu Hijo',
    number: 'TOMO 1',
    desc: 'Conocé la personalidad profunda de tu hijo: cómo piensa, cómo siente, qué lo mueve y qué necesita para florecer. Esta es la base de todo el sistema.',
    icon: <Heart className="w-6 h-6 text-dusty-rose-500" data-id="element-145" />
  }, {
    title: 'Su Forma de Aprender',
    number: 'TOMO 2',
    desc: 'Descubrí cómo aprende mejor tu hijo y transformá la hora de la tarea y los límites en momentos de conexión en lugar de batalla.',
    icon: <Brain className="w-6 h-6 text-dusty-rose-500" data-id="element-146" />
  }, {
    title: 'Sus Emociones y Cómo Acompañarlas',
    number: 'TOMO 3',
    desc: 'Entendé por qué reacciona como reacciona — y aprendé a acompañar sus emociones sin perder la calma ni sentirte culpable después.',
    icon: <Shield className="w-6 h-6 text-dusty-rose-500" data-id="element-147" />
  }, {
    title: 'Su Forma de Comunicarse',
    number: 'TOMO 4',
    desc: 'Aprendé a hablarle en su propio lenguaje para que te escuche, te entienda y responda de verdad.',
    icon: <MessageCircle className="w-6 h-6 text-dusty-rose-500" data-id="element-148" />
  }, {
    title: 'Crianza Sin Conflicto',
    number: 'TOMO 5',
    desc: 'Estrategias concretas y aplicables para reducir las peleas, las crisis y el agotamiento en tu vida cotidiana.',
    icon: <Book className="w-6 h-6 text-dusty-rose-500" data-id="element-149" />
  }, {
    title: 'Conexión Profunda',
    number: 'TOMO 6',
    desc: 'Construí el vínculo con tu hijo que lo acompañe y lo sostenga durante toda su vida.',
    icon: <Link className="w-6 h-6 text-dusty-rose-500" data-id="element-150" />
  }];
  const bonuses = [{
    title: 'Guía de Emergencia',
    number: 'BONUS 1',
    desc: 'Para usar en el momento exacto en que tu hijo explota, se cierra o no te escucha. Respuestas paso a paso. Inmediatas. Sin teoría.',
    icon: <AlertCircle className="w-6 h-6 text-gold-500" data-id="element-151" />
  }, {
    title: 'Diccionario de Conductas',
    number: 'BONUS 2',
    desc: 'Las 30 conductas más desafiantes de los niños explicadas con claridad y con una respuesta concreta y amorosa para cada una.',
    icon: <List className="w-6 h-6 text-gold-500" data-id="element-152" />
  }, {
    title: 'Rituales de Conexión',
    number: 'BONUS 3',
    desc: 'Rutinas simples de 5 minutos diarios para crear momentos reales de vínculo con tu hijo sin importar lo ocupada que estés.',
    icon: <Clock className="w-6 h-6 text-gold-500" data-id="element-153" />
  }];
  return <section className="py-10 px-4 bg-cream-50" data-id="element-154">
      <div className="max-w-6xl mx-auto" data-id="element-155">
        <FadeIn data-id="element-156">
          <h2 className="text-3xl md:text-5xl font-bold text-center text-burgundy-900 mb-16" data-id="element-157">
            Todo lo que recibís cuando te sumás hoy
          </h2>
        </FadeIn>

        {/* Tomos Section */}
        <div className="mb-20" data-id="element-158">
          <FadeIn data-id="element-159">
            <h3 className="text-2xl font-heading font-bold text-burgundy-800 mb-8 flex items-center justify-center gap-3" data-id="element-160">
              <span className="text-3xl" data-id="element-161">📚</span> LOS 6 TOMOS DE LA COLECCIÓN
            </h3>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-162">
            {tomos.map((tomo, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-163">
                <div className="bg-white rounded-2xl p-6 shadow-sm border border-cream-100 border-l-4 border-l-dusty-rose-300 h-full flex flex-col hover:shadow-md transition-shadow relative overflow-hidden" data-id="element-164">
                  <div className="absolute top-0 right-0 w-24 h-24 bg-dusty-rose-50 rounded-bl-full -z-10" data-id="element-165"></div>
                  <div className="flex items-center gap-3 mb-4" data-id="element-166">
                    <div className="p-2 bg-dusty-rose-100 rounded-lg" data-id="element-167">
                      {tomo.icon}
                    </div>
                    <div data-id="element-168">
                      <p className="text-xs font-bold text-dusty-rose-500 tracking-wider" data-id="element-169">
                        {tomo.number}
                      </p>
                      <h4 className="font-heading font-bold text-lg text-burgundy-900 leading-tight" data-id="element-170">
                        {tomo.title}
                      </h4>
                    </div>
                  </div>
                  <p className="text-burgundy-700 text-sm leading-relaxed flex-grow" data-id="element-171">
                    {tomo.desc}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </div>

        {/* Bonuses Section */}
        <div data-id="element-172">
          <FadeIn data-id="element-173">
            <h3 className="text-2xl font-heading font-bold text-burgundy-800 mb-8 flex items-center justify-center gap-3" data-id="element-174">
              <span className="text-3xl" data-id="element-175">🎁</span> LOS 3 BONUS EXCLUSIVOS
            </h3>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-176">
            {bonuses.map((bonus, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-177">
                <div className="bg-gradient-to-b from-gold-100 to-white rounded-2xl p-6 shadow-sm border border-gold-200 h-full flex flex-col hover:shadow-md transition-shadow relative overflow-hidden" data-id="element-178">
                  <div className="absolute -right-4 -top-4 w-20 h-20 bg-gold-200 rounded-full blur-xl opacity-50" data-id="element-179"></div>
                  <div className="flex items-center gap-3 mb-4 relative z-10" data-id="element-180">
                    <div className="p-2 bg-white rounded-lg shadow-sm" data-id="element-181">
                      {bonus.icon}
                    </div>
                    <div data-id="element-182">
                      <p className="text-xs font-bold text-gold-600 tracking-wider" data-id="element-183">
                        {bonus.number}
                      </p>
                      <h4 className="font-heading font-bold text-lg text-burgundy-900 leading-tight" data-id="element-184">
                        {bonus.title}
                      </h4>
                    </div>
                  </div>
                  <p className="text-burgundy-700 text-sm leading-relaxed flex-grow relative z-10" data-id="element-185">
                    {bonus.desc}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}